export class ScheduledTask {
  constructor(init = {}) {
    Object.assign(this, init);
    this.promise = new Promise((res, rej) => {
      this.resolve = res;
    });
  }

  promise: Promise<any>;
  unique: string;
  action: Function;
  resolve: Function;

  skipIfContains: string;
}
